// extracted by mini-css-extract-plugin
export var backdropBlur = "_m2-0";
export var contentCard = "_m2-5";
export var frame = "_m2-2";
export var image = "_m2-4";
export var imagePane = "_m2-3";
export var modal = "_m2-1";